// client/src/admin/resources/fasceOrarie.js
import * as React from 'react';
import { List, Datagrid, TextField, EditButton, DeleteButton,
         Edit, SimpleForm, TextInput, SelectInput, Create, required } from 'react-admin';

const giorni = ['Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato','Domenica'].map(g => ({ id: g, name: g }));
const tipi = ['ritiro','consegna','entrambi'].map(t => ({ id: t, name: t }));

export const FasciaList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="id_fornitore" />
      <TextField source="giorno_settimana" />
      <TextField source="orario_inizio" />
      <TextField source="orario_fine" />
      <TextField source="tipo" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const FasciaEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id_fornitore" validate={[required()]} />
      <SelectInput source="giorno_settimana" choices={giorni} validate={[required()]} />
      <TextInput source="orario_inizio" placeholder="HH:MM" validate={[required()]} />
      <TextInput source="orario_fine" placeholder="HH:MM" validate={[required()]} />
      <SelectInput source="tipo" choices={tipi} validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const FasciaCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="id_fornitore" validate={[required()]} />
      <SelectInput source="giorno_settimana" choices={giorni} validate={[required()]} />
      <TextInput source="orario_inizio" placeholder="HH:MM" validate={[required()]} />
      <TextInput source="orario_fine" placeholder="HH:MM" validate={[required()]} />
      <SelectInput source="tipo" choices={tipi} validate={[required()]} />
    </SimpleForm>
  </Create>
);
